import React, {Component} from 'react';
import {Card, CardBody, Carousel, CarouselCaption, CarouselControl, CarouselIndicators, CarouselItem} from 'reactstrap';
import './Banners.css';

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';
const labelStatus = ["Not Started", "Working", "", "", "", "", "", "", "", "Submitted", "Enrolled"];

export default class Banners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === this.props.banners.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({activeIndex: nextIndex});
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.activeIndex === 0 ? this.props.banners.length - 1 : this.state.activeIndex - 1;
    this.setState({activeIndex: nextIndex});
  }

  goToIndex(newIndex) {
    if (this.animating) return;
    this.setState({activeIndex: newIndex});
  }


  render() {
    if (!this.props.banners || this.props.banners.length === 0) return null;
    let activeIndex = this.state.activeIndex;
    const slides2 = this.props.banners.map((item, index) => {
      return (
        <CarouselItem
          onExiting={() => this.onExiting()}
          onExited={() => this.onExited()}
          key={index}
          src={item.src}
        >
          {/*<img className="d-block w-100" src={item.src} alt={""} key={item.src}/>*/}
          <CarouselCaption captionText={""} captionHeader={""}/>
        </CarouselItem>
      );
    });
    return (
      <Card style={{borderRadius: 10}}>
        <CardBody>
          <Carousel activeIndex={activeIndex}
                    next={() => this.next()} previous={() => this.previous()}
                    ride={'carousel'}
                    style={{marginLeft: "auto", marginRight: "auto"}}
          >
            <CarouselIndicators items={this.props.banners} activeIndex={activeIndex}
                                onClickHandler={(data) => this.goToIndex(data)}/>
            {slides2}
            <CarouselControl direction="prev" directionText="Previous" onClickHandler={() => this.previous()}/>
            <CarouselControl direction="next" directionText="Next" onClickHandler={() => this.next()}/>
          </Carousel>
        </CardBody>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Banners.js